import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

const Scroll = () => {
  const [isVisible, setIsVisible] = useState(false);

  const goToBtn = () => {
    window.scrollTo({ top: 0, right: 0, behavior: "smooth" });
  };

  const listenerScroll = () => {
    const heightToHide = 250;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToHide) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenerScroll, { passive: true });
    return () => window.removeEventListener("scroll", listenerScroll);
  }, []);

  return (
    <>
      {isVisible && (
        <button
          type="button"
          onClick={goToBtn}
          aria-label="Scroll to top"
          className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg transition hover:scale-105 hover:bg-blue-700"
        >
          <FaArrowUp size={22} />
        </button>
      )}
    </>
  );
};

export default Scroll;
